import React, { useState, useEffect } from 'react';
import './Guest.css';
import { useLocation } from 'react-router-dom';
import ActivityLogs from '../GlobalSearch/ActivityLogs.js';
import { hasPrivilege } from '../utils/hasPrivilege';
import { useUser } from "../context/UserContext";
const Guest = () => {
  const location = useLocation();
  const { userData } = useUser();
  const userId = location.state?.userId;
  const [guest, setGuest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLogs, setShowLogs] = useState(false);
  const token = localStorage.getItem('auth-token');
  useEffect(() => {
    const fetchGuest = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL_API_GUEST}/${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const { success, data, success_message } = await res.json();
        if (!success) throw new Error(success_message);

        const g = data.guest;
        setGuest({
          id: g.id || '',
          name: g.name || '',
          mobile: g.mobile_number || '',
          gender: g.genderType || '',
          dob: g.dob ?? 'Not provided',
          createdAt: g.createdAt || '',
        });
      } catch (err) {
        console.error('Failed to load guest:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGuest();
  }, [userId]);

  return (
    <div className="guest-container">
       {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}

      {error && <div className="error-message">{error}</div>}

      {!loading && !error && !guest && (
        <div className="error-message">No data available</div>
      )}

      {!loading && !error && guest && (
        <>
          <div className="guest-card">
            <div className="search-bar">
              <h3 className="guest-title">Guest Info</h3>
              {(hasPrivilege(userData, 'ACTIVITY_LOGS', 'ACTIVITY_LOGS_ALL_PLAYER_ACCESS') ||
  hasPrivilege(userData, 'ACTIVITY_LOGS', 'ACTIVITY_LOGS_SINGLE_PLAYER_ACCESS')) && (
              <button className="create-button" onClick={() => setShowLogs(!showLogs)}>
                {showLogs ? 'Hide Activity Logs' : 'Show Activity Logs'}
              </button>
  )}
            </div>
            <div className="guest-item">
              <span className="guest-label">Name</span>
              <span className="guest-value">{guest.name}</span>
            </div>
            <div className="guest-item">
              <span className="guest-label">Mobile</span>
              <span className="guest-value">{guest.mobile}</span>
            </div>
            <div className="guest-item">
              <span className="guest-label">Gender</span>
              <span className="guest-value">{guest.gender}</span>
            </div>
            <div className="guest-item">
              <span className="guest-label">Date of Birth</span>
              <span className="guest-value">{guest.dob}</span>
            </div>
          </div>

          {showLogs && (
            <div className="mt-10">
                <ActivityLogs userId={guest.id} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Guest;
